import styled from 'styled-components/macro';

export const HeaderBlockDiv = styled.div`
  padding-top: 5rem;
  margin-bottom: 5rem;
  @media screen and (min-width: 768px) {
    padding-top: 8rem;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 10rem;
  }
`;

export const HeaderBlockH3 = styled.h3`
  padding-bottom: 1rem;
`;

export const HeaderBlockP = styled.p`
  margin-top: 2rem;
`;

export const HeaderTitleDiv = styled.div`
  border-bottom: ${props => props.theme.defaultBorder};
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
